<ng-container *ngIf="layout != null && formGroup != null">
    <form [formGroup]="formGroup" class="transport-details-panel">
        <ng-container class="sequence" *ngFor="let sequence of layout.sequences; let i = index">
            <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
            <ng-container *ngIf="sequence?.identifier != null">
              <sc-title>{{sequence.identifier}}</sc-title>
              <sc-content-spacer vertical></sc-content-spacer>
            </ng-container>
            <sc-flex [startAligned]="true">
                <ng-container *ngFor="let column of sequence.columns; let j = index">
                    <sc-content-spacer *ngIf="j > 0"></sc-content-spacer>
                    <sc-flex-fitting-content [minSize]="250">
                        <ng-container *ngFor="let row of column.rows; let k = index">
                            <sc-content-spacer vertical *ngIf="k > 0" [half]="true"></sc-content-spacer>
                            <div class="row no-field-space">
                                <sc-flex>
                                    <ng-container *ngFor="let field of row.fields; let l = index">
                                        <sc-content-spacer *ngIf="l > 0" [half]="true"></sc-content-spacer>
                                        <ng-container *ngIf="field.detail?.isEditable">
                                            <app-transport-details-field-wrapper [field]="field" [formControlName]="field.identifier"
                                                [mode]="mode" [transport]="transport" (valueChange)="handleValueChange()"
                                                [disableAutoComplete]="disableAutoComplete"></app-transport-details-field-wrapper>
                                        </ng-container>
                                        <ng-container *ngIf="!field.detail?.isEditable">
                                            <app-transport-details-field-wrapper [field]="field"
                                                [mode]="mode" [transport]="transport"
                                                [disableAutoComplete]="disableAutoComplete"></app-transport-details-field-wrapper>
                                        </ng-container>
                                    </ng-container>
                                </sc-flex>
                            </div>
                        </ng-container>
                    </sc-flex-fitting-content>
                </ng-container>
            </sc-flex>
        </ng-container>
    </form>
</ng-container>
<ng-container *ngIf="layout == null">
    <sc-dictionary-label dictionaryKey="tbd-no-layout-available"></sc-dictionary-label>
</ng-container>
